import React from 'react';
import PublicNav from './PublicNav';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

const LOGO_URL = 'https://customer-assets-4nw71qhi.emergentagent.net/job_school-mgmt-72/artifacts/eluovc6p_ChatGPT%20Image%20Sep%2015%2C%202026%2C%2009_07_38%20AM.png';

export default function PublicPageWrapper({ children, title, subtitle }) {
  return (
    <div className="min-h-screen relative overflow-hidden" data-testid="public-page-wrapper">
      {/* Warm amber background */}
      <div className="absolute inset-0 bg-[#F5D882]" />

      {/* Decorative shapes */}
      <div className="absolute top-[-40px] right-[-50px] w-[250px] h-[250px] opacity-40">
        <svg viewBox="0 0 250 250"><path d="M120,10 Q200,60 180,160 Q140,240 60,220 Q10,160 40,80Z" fill="#1B3A6B" /><ellipse cx="200" cy="200" rx="40" ry="30" fill="#E8913A" /></svg>
      </div>
      <div className="absolute bottom-[-60px] left-[-30px] w-[280px] h-[220px] opacity-35">
        <svg viewBox="0 0 280 220"><ellipse cx="140" cy="110" rx="120" ry="90" fill="#3B7D4F" /><path d="M200,40 Q240,80 220,140 Q200,80 200,40Z" fill="#E8913A" /></svg>
      </div>

      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Floating card for nav + content */}
        <div className="flex-1 px-4 sm:px-6 lg:px-10 pt-6 pb-10">
          <div className="max-w-[1320px] mx-auto">
            <div className="bg-white rounded-[1.5rem] sm:rounded-[2rem] lg:rounded-[2.5rem] shadow-2xl shadow-amber-900/10 overflow-hidden min-h-[90vh]">
              {/* Nav inside card */}
              <PublicNav insideCard />

              {/* Page header */}
              {title && (
                <div className="px-6 sm:px-8 lg:px-12 pt-8 pb-6 border-b border-slate-100">
                  <h1 className="font-display text-2xl sm:text-3xl lg:text-4xl font-black text-[#1B2A4A] tracking-tight">{title}</h1>
                  {subtitle && <p className="text-slate-500 text-sm mt-2 max-w-2xl">{subtitle}</p>}
                </div>
              )}

              {/* Page content */}
              <div className="px-6 sm:px-8 lg:px-12 py-8 lg:py-10">
                {children}
              </div>
            </div>
          </div>
        </div>

        {/* Footer — outside card, on the amber background */}
        <footer className="relative z-10 px-4 sm:px-6 lg:px-10 pb-8">
          <div className="max-w-[1320px] mx-auto text-center">
            <div className="flex items-center gap-2 mb-3">
              <img src={LOGO_URL} alt="Tadam Academy" className="w-7 h-7 object-contain" />
              <span className="font-bold text-[#1B2A4A] text-sm">Tadam Academy</span>
            </div>
            <p className="text-xs text-[#1B2A4A]/60 font-medium">
              &copy; {new Date().getFullYear()} Tadam Academy. Mwana wako mwana wangu. | <a href="https://tadam.co.zw" className="underline hover:text-[#1B2A4A]">tadam.co.zw</a>
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}
